import { useEffect, useState } from "react";

const API = process.env.REACT_APP_NAV_API;

// const roleOptions = ["USER", "PC", "MIS", "HOD", "SALES", "ADMIN"];
// const roleOptions = ["USER", "PC", "MIS", "HOD", "SALES", "EM", "ADMIN"];

const styles = {
  wrapper: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
  },
tableWrapper: {
  background: "#ffffff",
  borderRadius: "16px",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(38,66,139,0.07)",
  border: "1px solid #E8EDF5",
  maxHeight: "650px",       // 👈 control height
  overflowY: "auto",        // 👈 enable vertical scroll
},
  tableHead: {
    background: "#F4F7FE",
  },
  th: {
    padding: "13px 18px",
    textAlign: "left",
    fontSize: "11px",
    fontWeight: "700",
    color: "#7B87A8",
    letterSpacing: "0.7px",
    textTransform: "uppercase",
    borderBottom: "1px solid #E8EDF5",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "13px 18px",
    fontSize: "13.5px",
    color: "#1A2340",
    borderBottom: "1px solid #F0F3FA",
    verticalAlign: "middle",
  },
  tdMuted: {
    padding: "13px 18px",
    fontSize: "13px",
    color: "#8A94A8",
    borderBottom: "1px solid #F0F3FA",
    verticalAlign: "middle",
  },
  tagList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  },
  roleTag: {
    display: "inline-block",
    padding: "3px 9px",
    borderRadius: "20px",
    fontSize: "11px",
    fontWeight: "600",
    background: "#EEF2FF",
    color: "#3B5BDB",
    letterSpacing: "0.2px",
  },
  processTag: {
    display: "inline-block",
    padding: "3px 9px",
    borderRadius: "20px",
    fontSize: "11px",
    fontWeight: "600",
    background: "#F0FDF4",
    color: "#16A34A",
    letterSpacing: "0.2px",
  },
  actionCell: {
    padding: "10px 18px",
    borderBottom: "1px solid #F0F3FA",
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  editBtn: {
    padding: "6px 14px",
    background: "#EEF2FF",
    color: "#3B5BDB",
    border: "none",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.12s",
  },
  deleteBtn: {
    padding: "6px 14px",
    background: "#FFF1F2",
    color: "#E03E52",
    border: "none",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.12s",
  },
  emptyRow: {
    textAlign: "center",
    padding: "40px",
    color: "#B0B9CE",
    fontSize: "14px",
  },

  // Modal shared
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(15,25,55,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(3px)",
    zIndex: 1000,
  },
  modalBox: {
    background: "#ffffff",
    borderRadius: "18px",
    padding: "32px 36px",
    width: "440px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
    border: "1px solid #E8EDF5",
    maxHeight: "80vh",
    overflowY: "auto",
  },
  modalTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#1A2340",
    margin: "0 0 22px 0",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "16px",
  },
  label: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#7B87A8",
    letterSpacing: "0.6px",
    textTransform: "uppercase",
  },
  input: {
    padding: "10px 14px",
    border: "1.5px solid #DDE3EF",
    borderRadius: "10px",
    fontSize: "14px",
    color: "#1A2340",
    background: "#FAFBFD",
    outline: "none",
  },
  checkboxSection: {
    background: "#F7F9FC",
    border: "1.5px solid #E8EDF5",
    borderRadius: "12px",
    padding: "12px 14px",
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    fontSize: "13px",
    fontWeight: "500",
    cursor: "pointer",
    padding: "5px 10px",
    borderRadius: "7px",
    userSelect: "none",
    transition: "background 0.12s",
  },
  checkbox: {
    width: "14px",
    height: "14px",
    accentColor: "#3B5BDB",
    cursor: "pointer",
  },
  divider: {
    height: "1px",
    background: "#EEF1F7",
    margin: "16px 0",
  },
  modalBtns: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
  },
  saveBtn: {
    flex: 1,
    padding: "11px",
    background: "linear-gradient(135deg, #3B5BDB 0%, #4C6EF5 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(59,91,219,0.3)",
  },
  cancelBtn: {
    flex: 1,
    padding: "11px",
    background: "#F0F3FA",
    color: "#5A6480",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
  deleteConfirmBtn: {
    flex: 1,
    padding: "11px",
    background: "linear-gradient(135deg, #E03E52 0%, #F06878 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(224,62,82,0.3)",
  },
  deleteModalIcon: {
    width: "48px",
    height: "48px",
    borderRadius: "14px",
    background: "#FFF1F2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  },
};

export default function AccessTable() {
  const [data, setData] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [roleOptions, setRoleOptions] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [filters, setFilters] = useState({
  name: "",
  department: "",
});
const [misProcesses, setMisProcesses] = useState([]);
const [emProcesses, setEmProcesses] = useState([]);
// ✅ NEW
const [currentPage, setCurrentPage] = useState(1);
const rowsPerPage = 20;

  useEffect(() => {
    fetch(`${API}/admin/access`, {
  credentials: "include"
})
      .then(r => r.json())
      .then(d => setData(d.items || []));
  }, []);

  useEffect(() => {
    fetch(`${API}/admin/processes`, {
  credentials: "include"
})
      .then(r => r.json())
      .then(d => setProcesses(d.items || []));
  }, []);

  useEffect(() => {
  fetch(`${API}/admin/mis-processes`, {
  credentials: "include"
})
    .then(r => r.json())
    .then(d => setMisProcesses(d.items || []));
}, []);
useEffect(() => {
  fetch(`${API}/admin/em-processes`, {
    credentials: "include"
  })
    .then(r => r.json())
    .then(d => setEmProcesses(d.items || []));
}, []);

useEffect(() => {
  fetch(`${API}/nav/roles`, {
    credentials: "include"   // ✅ ADD THIS
  })
    .then(r => r.json())
    .then(d => setRoleOptions(d.items || []))
    .catch(err => console.error("Failed to load roles", err));
}, []);
function handleDelete() {
  fetch(`${API}/admin/access/${confirmDelete}`, {
    method: "DELETE",
    credentials: "include" // 👈 ADD THIS
  })
  .then(() => {
    setData(prev => prev.filter(x => x.email !== confirmDelete));
    setConfirmDelete(null);
  });
}

  function handleUpdate() {
    fetch(`${API}/admin/access`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(editRow),
    }).then(() => {
      setEditRow(null);
      window.location.reload();
    });
  }

  // ✅ ADD HERE
// ✅ UPDATED (filter + sort)
const filteredData = data
  .filter(row => {
    const matchName = row.name?.toLowerCase().includes(filters.name.toLowerCase());
    const matchDept = filters.department
      ? row.department === filters.department
      : true;

    return matchName && matchDept;
  })
  .sort((a, b) => (a.department || "").localeCompare(b.department || ""));

  // ✅ NEW PAGINATION LOGIC
const totalPages = Math.ceil(filteredData.length / rowsPerPage);

const paginatedData = filteredData.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);


  return (
    <div style={styles.wrapper}>
        <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>
  <input
    placeholder="Search Name..."
    style={{ ...styles.input, width: "200px" }}
    value={filters.name}
    onChange={(e) => {
  setFilters({ ...filters, name: e.target.value });
  setCurrentPage(1); // ✅ reset page
}}
  />

  <select
    style={{ ...styles.input, width: "200px" }}
    value={filters.department}
    onChange={(e) => {
  setFilters({ ...filters, department: e.target.value });
  setCurrentPage(1); // ✅ reset page
}}
  >
    <option value="">All Departments</option>
    {[...new Set(data.map(d => d.department).filter(Boolean))].map(dep => (
      <option key={dep} value={dep}>{dep}</option>
    ))}
  </select>
</div>
      <div style={styles.tableWrapper}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={styles.tableHead}>
            <tr>
              {["Email", "Name", "Department", "Roles", "Process Access", "MIS Access", "Actions"].map(h => (
                <th key={h} style={styles.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan={7} style={styles.emptyRow}>No matching records</td>
              </tr>
            ) : paginatedData.map((row, i) => (
              <tr
                key={row.email}
                style={{ background: i % 2 === 0 ? "#ffffff" : "#FAFBFD" }}
              >
                <td style={styles.td}>{row.email}</td>
                <td style={styles.td}>{row.name}</td>
                <td style={styles.tdMuted}>{row.department}</td>
                <td style={{ ...styles.td, padding: "10px 18px" }}>
                  <div style={styles.tagList}>
                    {(row.roles ? row.roles.split(",") : []).map(r => r.trim()).filter(Boolean).map(r => (
                      <span key={r} style={styles.roleTag}>{r}</span>
                    ))}
                  </div>
                </td>
                {/* Process Access */}
                <td style={{ ...styles.td, padding: "10px 18px" }}>
                  <div style={styles.tagList}>
                    {(row.process_access ? row.process_access.split(",") : [])
                      .map(p => p.trim())
                      .filter(Boolean)
                      .map(p => (
                        <span key={p} style={styles.processTag}>{p}</span>
                      ))}
                  </div>
                </td>
                
                {/* MIS Access */}
                <td style={{ ...styles.td, padding: "10px 18px" }}>
                  <div style={styles.tagList}>
                    {(row.mis_access ? row.mis_access.split(",") : [])
                      .map(p => p.trim())
                      .filter(Boolean)
                      .map(p => (
                        <span key={p} style={styles.processTag}>{p}</span>
                      ))}
                  </div>
                </td>
                <td style={styles.actionCell}>
                  <button
                    style={styles.editBtn}
                   onClick={() => setEditRow({
  ...row,
  roles: row.roles ? row.roles.split(",") : [],
  process_access: row.process_access ? row.process_access.split(",") : [],
  mis_access: row.mis_access ? row.mis_access.split(",") : [],
  em_access: row.em_access ? row.em_access.split(",") : [],
})}
                  >
                    Edit
                  </button>
                  <button style={styles.deleteBtn} onClick={() => setConfirmDelete(row.email)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ✅ PAGINATION */}
<div style={{
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "12px",
  padding: "0 6px"
}}>
  <span style={{ fontSize: "12px", color: "#7B87A8" }}>
    Showing {Math.min((currentPage - 1) * rowsPerPage + 1, filteredData.length)} -{" "}
    {Math.min(currentPage * rowsPerPage, filteredData.length)} of {filteredData.length}
  </span>

  <div style={{ display: "flex", gap: "6px" }}>
    <button
      style={styles.cancelBtn}
      disabled={currentPage === 1}
      onClick={() => setCurrentPage(prev => prev - 1)}
    >
      Prev
    </button>

    {Array.from({ length: totalPages }, (_, i) => (
      <button
        key={i}
        onClick={() => setCurrentPage(i + 1)}
        style={{
          ...styles.editBtn,
          background: currentPage === i + 1 ? "#3B5BDB" : "#EEF2FF",
          color: currentPage === i + 1 ? "#fff" : "#3B5BDB",
        }}
      >
        {i + 1}
      </button>
    ))}

    <button
      style={styles.cancelBtn}
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage(prev => prev + 1)}
    >
      Next
    </button>
  </div>
</div>

      {/* Edit Modal */}
      {editRow && (
        <div style={styles.overlay}>
          <div style={styles.modalBox}>
            <p style={styles.modalTitle}>Edit Access</p>

            <div style={styles.field}>
              <label style={styles.label}>Full Name</label>
              <input
                style={styles.input}
                value={editRow.name}
                onChange={e => setEditRow({ ...editRow, name: e.target.value })}
              />
            </div>

            <div style={styles.divider} />

            <div style={styles.field}>
              <label style={styles.label}>Roles</label>
              <div style={styles.checkboxSection}>
                {roleOptions.map(r => (
                  <label
                    key={r}
                    style={{
                      ...styles.checkboxLabel,
                      background: editRow.roles.includes(r) ? "#EEF2FF" : "transparent",
                      color: editRow.roles.includes(r) ? "#3B5BDB" : "#2D3A5E",
                    }}
                  >
                    <input
                      type="checkbox"
                      style={styles.checkbox}
                      checked={editRow.roles.includes(r)}
                      onChange={() => {
                        setEditRow(prev => ({
                          ...prev,
                          roles: prev.roles.includes(r)
                            ? prev.roles.filter(x => x !== r)
                            : [...prev.roles, r],
                        }));
                      }}
                    />
                    {r}
                  </label>
                ))}
              </div>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Process Access</label>
              <div style={styles.checkboxSection}>
                {processes.map(p => (
                  <label
                    key={p}
                    style={{
                      ...styles.checkboxLabel,
                      background: editRow.process_access.includes(p) ? "#EEF2FF" : "transparent",
                      color: editRow.process_access.includes(p) ? "#3B5BDB" : "#2D3A5E",
                    }}
                  >
                    <input
                      type="checkbox"
                      style={styles.checkbox}
                      checked={editRow.process_access.includes(p)}
                      onChange={() => {
                        setEditRow(prev => ({
                          ...prev,
                          process_access: prev.process_access.includes(p)
                            ? prev.process_access.filter(x => x !== p)
                            : [...prev.process_access, p],
                        }));
                      }}
                    />
                    {p}
                  </label>
                ))}
              </div>
            </div>


            {/* MIS Access (only if MIS role selected) */}
{editRow.roles.includes("MIS") && (
  <div style={styles.field}>
    <label style={styles.label}>MIS Access</label>
    <div style={styles.checkboxSection}>
      {misProcesses.map(p => (
        <label
          key={p}
          style={{
            ...styles.checkboxLabel,
            background: editRow.mis_access.includes(p) ? "#EEF2FF" : "transparent",
            color: editRow.mis_access.includes(p) ? "#3B5BDB" : "#2D3A5E",
          }}
        >
          <input
            type="checkbox"
            style={styles.checkbox}
            checked={editRow.mis_access.includes(p)}
            onChange={() => {
              setEditRow(prev => ({
                ...prev,
                mis_access: prev.mis_access.includes(p)
                  ? prev.mis_access.filter(x => x !== p)
                  : [...prev.mis_access, p],
              }));
            }}
          />
          {p}
        </label>
      ))}
    </div>
  </div>
)}

{/* EM Access (only if EM role selected) */}
{editRow.roles.includes("EM") && (
  <div style={styles.field}>
    <label style={styles.label}>EM Access</label>

    <div style={styles.checkboxSection}>
      {emProcesses.map(p => (
        <label
          key={p}
          style={{
            ...styles.checkboxLabel,
            background: editRow.em_access.includes(p)
              ? "#EEF2FF"
              : "transparent",
            color: editRow.em_access.includes(p)
              ? "#3B5BDB"
              : "#2D3A5E",
          }}
        >
          <input
            type="checkbox"
            style={styles.checkbox}
            checked={editRow.em_access.includes(p)}
            onChange={() => {
              setEditRow(prev => ({
                ...prev,
                em_access: prev.em_access.includes(p)
                  ? prev.em_access.filter(x => x !== p)
                  : [...prev.em_access, p],
              }));
            }}
          />
          {p}
        </label>
      ))}
    </div>
  </div>
)}

            <div style={styles.modalBtns}>
              <button style={styles.saveBtn} onClick={handleUpdate}>Save Changes</button>
              <button style={styles.cancelBtn} onClick={() => setEditRow(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirm Modal */}
      {confirmDelete && (
        <div style={styles.overlay}>
          <div style={{ ...styles.modalBox, width: "340px" }}>
            <div style={styles.deleteModalIcon}>
              <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="#E03E52" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <p style={{ ...styles.modalTitle, marginBottom: "6px" }}>Delete Access</p>
            <p style={{ fontSize: "13px", color: "#8A94A8", marginBottom: "0" }}>
              Are you sure you want to remove access for <strong style={{ color: "#1A2340" }}>{confirmDelete}</strong>? This cannot be undone.
            </p>
            <div style={styles.modalBtns}>
              <button style={styles.deleteConfirmBtn} onClick={handleDelete}>Yes, Delete</button>
              <button style={styles.cancelBtn} onClick={() => setConfirmDelete(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}